<template>
    <div ref="host"></div>
</template>

<script>
    /**
     * Renderiza HTML externo (p.ej. contenido de WordPress) dentro de un
     * Shadow DOM, de forma que sus estilos quedan completamente aislados:
     * los <style> y clases del CMS no afectan al resto de la SPA, y los
     * estilos globales de la SPA no entran al contenido.
     */
    export default {
        name: 'ShadowHtml',

        props: {
            html: {
                type: String,
                default: ''
            }
        },

        mounted() {
            this.shadowRoot = this.$refs.host.attachShadow({ mode: 'open' });
            this.render();
        },

        watch: {
            html() {
                this.render();
            }
        },

        methods: {
            render() {
                if (this.shadowRoot) {
                    this.shadowRoot.innerHTML = this.html || '';
                }
            }
        }
    }
</script>
